import React from "react"
import { Box, Grid, Typography } from "@mui/material"
import * as Style from "../style"
import moment from "moment"
import { Link } from "react-router-dom"
import whiteLogo from "../../../images/logo-white.svg"
import { useGetOffersQuery } from "../../../features/OverViewAuth/overViewApi"
import CenteredSpinner from "../../common/CenteredSpinner"
import OfferPage from "./OfferPage"
const Offers = () => {
  const {
    data: getOffers,
    isFetching,
    isLoading,
  } = useGetOffersQuery({ limit: 100 })

  return (
    <>
      {" "}
      {isFetching || isLoading ? (
        <CenteredSpinner />
      ) : (
        <Box className="pt-5 px-md-5">
          <Style.Overview>
            <Typography
              variant="body1"
              className="font-25 pink-text mb-1 fw-semibold"
            >
              Offers
            </Typography>

            <Grid container className="mb-4">
              {getOffers?.data?.map((item: any) => (
                <Grid item xs={12} xl={6}>
                  <Box>
                    <Box className="offer-box me-2 mb-2">
                      <Box className="offer-box-content">
                        <img src={whiteLogo} className="logo-white" />
                        <Typography className="off-discount">
                          {item?.offerAmount}% OFF
                        </Typography>
                        <Typography className="valid-text">
                          Valid upto
                        </Typography>
                        <Typography className="mb-4 valid-date-text">
                          {moment(item?.validDetails?.expiryDate).format(
                            "DD MMMM",
                          )}
                        </Typography>
                        <Typography className="book-text">
                          Book Your Services Now!
                        </Typography>
                        <Link
                          to={`/dashboard/create-booking?type=${item?._id}`}
                          className="book-now-btn"
                        >
                          Book Now
                        </Link>
                      </Box>
                      <img src={item?.image} className="offer-img" />
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
            {getOffers?.data?.length > 0 && (
              <Typography variant="body1" className="mb-4">
                Showing {getOffers?.data?.length} elements
              </Typography>
            )}
            <OfferPage />
          </Style.Overview>
        </Box>
      )}
    </>
  )
}
export default Offers
